import { useState } from "react";
import { Link } from "react-router-dom";
import { STORES } from "@shared/stores";
import { logoutUrl } from "../lib/auth";

export function Settings() {
  const [exportStore, setExportStore] = useState(STORES[0]?.code ?? "GV");

  return (
    <div className="max-w-3xl mx-auto p-6">
      <Link to="/" className="text-sm text-accent hover:underline">← Home</Link>
      <h2 className="text-2xl font-semibold mt-4 mb-6">Settings</h2>

      <section className="bg-surface border border-border rounded-lg p-5 mb-4">
        <h3 className="text-sm font-semibold mb-3">Default location</h3>
        <select className="border border-border rounded px-3 py-2 text-sm w-full max-w-sm">
          {STORES.map((s) => (
            <option key={s.code} value={s.code}>{s.city} ({s.code})</option>
          ))}
        </select>
      </section>

      <section className="bg-surface border border-border rounded-lg p-5 mb-4">
        <h3 className="text-sm font-semibold mb-3">PK imports</h3>
        <p className="text-sm text-ink-soft mb-3">
          Download a CSV of every unlinked patient from this store. Run it through PK →
          Export/Import → <strong>Import Patients (File)</strong>, Format #2.
          PK skips existing patients by (last, first, address) so it's safe to include everyone.
        </p>
        <div className="flex items-center gap-2 flex-wrap">
          <select
            value={exportStore}
            onChange={(e) => setExportStore(e.target.value)}
            className="border border-border rounded px-3 py-2 text-sm"
          >
            {STORES.map((s) => (
              <option key={s.code} value={s.code}>{s.city} ({s.code})</option>
            ))}
          </select>
          <a
            href={`/api/exports/new-patients?store=${exportStore}`}
            className="px-4 py-2 bg-accent text-white rounded text-sm font-medium hover:brightness-95"
          >
            Download new-patients CSV
          </a>
        </div>
      </section>

      <section className="bg-surface border border-border rounded-lg p-5 mb-4">
        <h3 className="text-sm font-semibold mb-3">Notifications</h3>
        <p className="text-sm text-ink-soft">Coming next — toggles for new-Rx, hold-resolved, controlled-Rx alerts.</p>
      </section>

      <a
        href={logoutUrl()}
        className="inline-block px-4 py-2 border border-bad text-bad rounded text-sm hover:bg-bad-soft"
      >
        Sign out
      </a>
    </div>
  );
}
